import apiClient, { dataOf, type ApiResponse } from './client'

export interface FaceAuthSession {
  id: number
  session_id: string
  h5_url: string
  qr_payload: string
  expires_at: string
}
export interface FaceAuthGroup {
  id: number
  group_id: string
  artist_label: string
  status: 'active' | 'disabled'
  authorized_at: string | null
  authorization_starts_at: string | null
  authorization_expires_at: string | null
  last_synced_at: string | null
  asset_count: number
  disabled_reason: string
}
export interface GroupRegistration {
  group_id: string
  artist_label: string
  authorized_at?: string
  authorization_starts_at?: string
  authorization_expires_at?: string
}
export const faceAuthApi = {
  create: (artist_label: string) => dataOf(apiClient.post<ApiResponse<FaceAuthSession>>('/face-auth/sessions', { artist_label })),
  groups: (page: number, status: string) => dataOf(apiClient.get<ApiResponse<{ groups: FaceAuthGroup[]; total: number }>>('/face-auth/groups', { params: { page, page_size: 20, status } })),
  register: (input: GroupRegistration) => dataOf(apiClient.post<ApiResponse<FaceAuthGroup>>('/face-auth/groups', input)),
  sync: (id: string) => dataOf(apiClient.post<ApiResponse<{ imported: number; updated: number; fetched: number }>>(`/face-auth/groups/${encodeURIComponent(id)}/sync`, undefined, { timeout: 660000 })),
  disable: (input: { group_id: string; reason: string }) => dataOf(apiClient.post<ApiResponse<FaceAuthGroup>>(`/face-auth/groups/${encodeURIComponent(input.group_id)}/disable`, { reason: input.reason })),
}
